export default __webpack_public_path__ + "static/media/Abstarct-Noise-0.1.213f58f7.jpg";